(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  /* Event-delegated disclosure dropdown — works for blocks added/removed via customizer Section Rendering API. */
  document.addEventListener('click', function(e){
    var trig = e.target.closest('.hdr-drop-trig');
    if (trig){
      var open = trig.getAttribute('aria-expanded') === 'true';
      /* Close any other open dropdowns first */
      document.querySelectorAll('.hdr-drop-trig[aria-expanded="true"]').forEach(function(t){
        if (t !== trig) t.setAttribute('aria-expanded','false');
      });
      trig.setAttribute('aria-expanded', open ? 'false' : 'true');
      e.stopPropagation();
      return;
    }
    /* Click anywhere else closes open dropdowns */
    if (!e.target.closest('.hdr-drop-panel')){
      document.querySelectorAll('.hdr-drop-trig[aria-expanded="true"]').forEach(function(t){
        t.setAttribute('aria-expanded','false');
      });
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      document.querySelectorAll('.hdr-drop-trig[aria-expanded="true"]').forEach(function(t){
        t.setAttribute('aria-expanded','false');
        t.focus();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
